export const EditIcon = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.3143 16.5861H9.69188M1 17L5.59366 15.2332C5.88748 15.1202 6.03439 15.0637 6.17184 14.9899C6.29392 14.9244 6.41031 14.8487 6.51978 14.7638C6.64302 14.6682 6.75432 14.5569 6.97692 14.3343L16.3142 4.99696C17.2286 4.0826 17.2286 2.60013 16.3142 1.68577C15.3999 0.771411 13.9174 0.77141 13.0031 1.68577L3.66574 11.0231C3.44314 11.2457 3.33184 11.357 3.2362 11.4802C3.15125 11.5897 3.07562 11.7061 3.01008 11.8282C2.9363 11.9656 2.8798 12.1125 2.76679 12.4063L1 17ZM1 17L2.7037 12.5704C2.82562 12.2534 2.88658 12.095 2.99113 12.0224C3.0825 11.9589 3.19557 11.9349 3.30483 11.9558C3.42986 11.9797 3.54993 12.0997 3.79007 12.3399L5.66014 14.21C5.90028 14.4501 6.02035 14.5702 6.04423 14.6952C6.0651 14.8045 6.0411 14.9175 5.97766 15.0089C5.90506 15.1134 5.74657 15.1744 5.4296 15.2963L1 17Z"
        stroke={props?.stroke || "#3B454F"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
